import React from "react";
import InputLabel from "@mui/material/InputLabel";
import { FormControl } from "../FormControl";
import { Tooltip } from "@mui/material";
import styled from "styled-components";

import { ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { PropertyEditorText } from "../../../CommonUI/PropertyEditing/PropertyEditorText";
import { PropertyEditorBoolean } from "../../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import { PropertyEditorInteger } from "../../../CommonUI/PropertyEditing/PropertyEditorInteger";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { PropertyEditorCollapse } from "../../../CommonUI/PropertyEditing/PropertyEditorCollapse";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

class XLabelEditUI extends React.Component<{ editMe: LabelFormControl }> {
    render() {
        return (
            <UISpacedBoxContent>
                <PropertyEditorText
                    editObject={this.props.editMe}
                    propertyName="htmlFor"
                    label="Label For"
                />
                <PropertyEditorInteger
                    editObject={this.props.editMe}
                    propertyName="maxLength"
                    label="Max Length"
                />
                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    propertyName="fromData"
                    label="From Data?"
                />
                <PropertyEditorCollapse
                    editObject={this.props.editMe}
                    collapseLogicOrField={"fromData"}
                >
                    <PropertyEditorText
                        editObject={this.props.editMe}
                        propertyName="valueName"
                        label="Value Name For Data"
                    />
                </PropertyEditorCollapse>
                <PropertyEditorCollapse
                    editObject={this.props.editMe}
                    collapseLogicOrField={"fromData"}
                    showIfFalse={true}
                >
                    <PropertyEditorText
                        editObject={this.props.editMe}
                        propertyName="text"
                        label="Static Text"
                    />
                </PropertyEditorCollapse>
            </UISpacedBoxContent>
        );
    }
}

export class LabelFormControl extends FormControl {
    readonly __type: string = "Label";
    text: string = "Label Text";
    htmlFor: string = "html-for";
    valueName?: string;
    fromData: boolean = false;
    maxLength: number = 2000;

    constructor() {
        super();
        this.canFocus = false;
    }

    render() {
        const labelText = this.fromData ? (this.valueName ? this.getFormDataValue(this.valueName) : "") : this.text;

        if ((labelText || "").length > this.maxLength) {
            return (
                <Tooltip title={labelText}>
                    <StyledLabel
                        style={{ width: "100%" }}
                        htmlFor={this.htmlFor}
                        data-testid="xlabel"
                    >
                        {labelText.slice(0, this.maxLength)}...
                    </StyledLabel>
                </Tooltip>
            );
        }

        return (
            <StyledLabel
                style={{ width: "100%" }}
                htmlFor={this.htmlFor}
                data-testid="xlabel"
            >
                {labelText}
            </StyledLabel>
        );
    }

    renderEditUI(): JSX.Element | null {
        return <XLabelEditUI editMe={this} />;
    }

    getDesignValidationIssues(): ValidationIssue[] {
        return [];
    }

    getRuntimeValidationIssues(): ValidationIssue[] {
        return [];
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        return;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(
            this,
            retData,
            "__type",
            "text",
            "htmlFor",
            "valueName",
            "fromData",
            "maxLength",
        );

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type", "text", "htmlFor", "valueName", "fromData", "maxLength");
    }
}

const StyledLabel = styled(InputLabel)`
    && {
        //styleName: text/Inter SemiBold 12px;

        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 17px;
        letter-spacing: 0px;
        text-align: left;
        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
    }
`;
